import React from "react";
import { get } from "lodash-es";
import { YesNoButtons } from "../../../components/FormComponents/YesNoButtons";
import { connect, Field } from "formik";
import { InputField } from "@coverme/forms";
import { DateInput } from "../../../components/FormComponents/DateInput";
import { getAge } from "../../../services/stringService";

const PregnancyComponent = ({
    fullName,
    fieldSection,
    getErrors,
    isRequired,
    getValidationState,
    formik: { setFieldValue, values, ...props },
}) => {
    function getFieldName(fieldName) {
        if (fieldSection != null) {
            return `${fieldSection}.pregnancy.${fieldName}`;
        }
        return `pregnancy.${fieldName}`;
    }
    return (
        <div className="form-section">
            <div className="form-control xxl-input">
                <YesNoButtons
                    {...props}
                    name={`${getFieldName("isPregnant")}`}
                    title={`Is ${fullName || "this person"} pregnant?`}
                    setFieldValue={setFieldValue}
                    isRequired={isRequired}
                    getErrors={getErrors}
                    getValidationState={getValidationState}
                />
            </div>
            {get(values, `${getFieldName("isPregnant")}`) && (
                <>
                    <div className="form-control auto-input">
                        <Field
                            name={`${getFieldName("expectedChildren")}`}
                            render={({ field }) => (
                                <InputField
                                    {...field}
                                    id={field.name}
                                    title={"How many children are expected?"}
                                    placeholder={"1"}
                                    type={"number"}
                                    min={1}
                                    errorMessage={getErrors(field)}
                                    validState={getValidationState(field)}
                                    required={isRequired(field)}
                                    changeEvent={e => {
                                        setFieldValue(field.name, e.target.value);
                                    }}
                                />
                            )}
                        />
                    </div>
                    <div className="form-control xl-input">
                        <Field
                            name={`${getFieldName("expectedDueDate")}`}
                            render={({ field }) => (
                                <DateInput
                                    {...field}
                                    id={field.name}
                                    changeEvent={e => {
                                        setFieldValue(field.name, e);
                                    }}
                                    title={"What is the expected due date?"}
                                    disabled={false}
                                    required={isRequired(field)}
                                    errorMessage={getErrors(field)}
                                    validState={getValidationState(field)}
                                />
                            )}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export const PregnancyField = connect(PregnancyComponent);

export default PregnancyField;
